import React from "react";

// material-ui
import { Box, IconButton, Tooltip } from "@mui/material";

// project imports
import LogoSection from "./LogoSection";
import ProfileSection from "./ProfileSection";
import { SIDEBAR_WIDTH } from "../../theme";

// assets
import { IconMenu2 } from "@tabler/icons";
import { Link } from "react-router-dom";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

/**
 * The top bar: logo, drawer toggle, and whoever is signed in.
 *
 * The logo block is exactly as wide as the sidebar, so the logo and the
 * navigation below it share a left edge. It used to be sized in `vw`, which
 * meant the two lined up at one window width and at no other.
 */
const Header = ({ handleLeftDrawerToggle }) => {
  return (
    <>
      <Box
        sx={{
          width: { xs: "auto", md: SIDEBAR_WIDTH },
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
        }}
      >
        <Box
          component={Link}
          to="/"
          sx={{ display: { xs: "none", md: "block" }, lineHeight: 0 }}
        >
          <LogoSection />
        </Box>

        <Tooltip title="Toggle navigation">
          <IconButton
            onClick={handleLeftDrawerToggle}
            size="small"
            sx={{ width: 36, height: 36 }}
            aria-label="Toggle navigation"
          >
            <IconMenu2
              stroke={1.8}
              size="1.25rem"
            />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ flexGrow: 1 }} />

      <ProfileSection />
    </>
  );
};

export default Header;
